// Gusto39 Kategorie: Filter-Schublade, Sortierung, „Weitere zeigen“, Mengenwahl in der Karte.
// Ohne JavaScript bleibt alles bedienbar: Filter und Sortierung sind ein normales GET-Formular, „Weitere zeigen“ ein Link.
(() => {
  document.documentElement.classList.add('js');
  const dialog = document.getElementById('CollectionFilters');
  const form = document.getElementById('CollectionFiltersForm');
  const opener = document.querySelector('[data-filters-open]');
  const desktop = matchMedia('(min-width: 1024px)');

  if (dialog && opener) {
    opener.addEventListener('click', () => {
      dialog.showModal();
      opener.setAttribute('aria-expanded', 'true');
    });
    dialog.addEventListener('close', () => {
      opener.setAttribute('aria-expanded', 'false');
      opener.focus();
    });
    dialog.querySelector('[data-filters-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    desktop.addEventListener('change', (event) => { if (event.matches && dialog.open) dialog.close(); });
  }

  if (form) {
    // Leere Felder nicht in die URL schreiben.
    form.addEventListener('formdata', (event) => {
      for (const [key, value] of [...event.formData.entries()]) if (value === '') event.formData.delete(key);
    });
    // Desktop: Filter wirken sofort. Mobil erst mit „Ergebnisse zeigen“.
    form.addEventListener('change', (event) => {
      if (desktop.matches && event.target.type === 'checkbox') form.requestSubmit();
    });
    document.querySelector('[data-sort]')?.addEventListener('change', () => form.requestSubmit());
    // Suche: Wurden alle Filter abgewählt, gibt es das ganze Sortiment statt nur der Suchtreffer.
    form.addEventListener('submit', (event) => {
      if (!form.dataset.allUrl || Number(form.dataset.active) === 0 || form.querySelector('input[type="checkbox"]:checked')) return;
      event.preventDefault();
      window.location.href = form.dataset.allUrl;
    });
  }

  // „Weitere zeigen“: nächste Seite laden und Karten anhängen.
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-load-more]');
    if (!link) return;
    event.preventDefault();
    link.setAttribute('aria-busy', 'true');
    try {
      const html = await (await fetch(link.href)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = document.querySelector('[data-grid]');
      const items = doc.querySelectorAll('[data-grid] > li');
      const firstNew = items[0];
      grid.append(...items);
      const next = doc.querySelector('[data-load-more]');
      if (next) link.replaceWith(next); else link.remove();
      const status = doc.querySelector('[data-load-status]');
      if (status) document.querySelector('[data-load-status]').textContent = status.textContent;
      firstNew?.querySelector('a[href]:not([tabindex="-1"])')?.focus();
    } catch {
      window.location.href = link.href;
    }
  });

  // Mengenwahl in der Produktkarte.
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-qty]');
    if (!btn) return;
    const input = btn.parentElement.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(btn.dataset.qty));
  });
})();
